import React, { useState } from 'react';
import EditorSettings from '@wix/da-ds/pkg/Icons/24x24/EditorSettings';
import { ButtonProps } from '../../../../../components/menus/buttons/types';
import { useTranslation } from 'react-i18next';
import SettingsForm from './SettingsForm';
import EditorIconButton from '../../../../../components/menus/_partials/EditorIconButton';

const Settings: React.FC<ButtonProps> = ({ editor }) => {
  const { t } = useTranslation('editor');

  const [showSettings, setShowSettings] = useState(false);

  return (
    <>
      {showSettings && (
        <SettingsForm
          editor={editor}
          onClose={() => {
            setShowSettings(false);
          }}
        />
      )}
      <EditorIconButton
        featureId="node:gallery:settings"
        icon={EditorSettings}
        onClick={() => {
          setShowSettings(true);
        }}
        tooltipText={t('ext.gallery.toolbar.settings')}
        aria-label={t('ext.gallery.toolbar.settings')}
      />
    </>
  );
};
Settings.displayName = 'Settings';

export default Settings;
